import { gql } from "@apollo/client"

const GET_INVITATIONS_SENT_COUNT = gql`
  query($id: ID) {
    event(id: $id) {
      id
      no_of_invitations_sent
    }
  }
`


export { GET_INVITATIONS_SENT_COUNT }
